// extracted by mini-css-extract-plugin
module.exports = {"iconBase":"IconBase_iconBase__OXv8f"};